export const SERVER_TIME_ZONE = 'Europe/Berlin';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
